<h1 mat-dialog-title>Medidas</h1>
<div mat-dialog-content>
  <ng-container *ngTemplateOutlet="templateForm"></ng-container>
</div>
<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close class="app-btn-close">
    Cerrar
  </button>
  <button
    class="app-btn-save"
    mat-raised-button
    [disabled]="mainForm.invalid || data.isReadonly"
    (click)="onClickSave()"
  >
    Guardar cambios
  </button>
</div>
<ng-template #templateForm>
  <form [formGroup]="mainForm" class="main-form">
    <!--    <div class="">-->
    <mat-form-field appearance="fill">
      <mat-label>Número de parte</mat-label>
      <input matInput type="text" formControlName="assemblyName" />
    </mat-form-field>
    <mat-form-field appearance="fill" [hidden]="!showFormForMeasures">
      <mat-label>Grupos</mat-label>
      <input matInput formControlName="numberOfGroups" type="number" />
    </mat-form-field>
    <mat-form-field
      appearance="fill"
      [hidden]="!(showVisualInspection$ | async)"
    >
      <mat-label>Tipo AQL</mat-label>
      <mat-select formControlName="aqlType">
        <mat-option>
          <ngx-mat-select-search
            formControlName="searchAqlType"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let val of aqlTypes$ | async" [value]="val.id">
          {{ val.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" *ngIf="showFormForMeasures">
      <mat-label>Url drive</mat-label>
      <input matInput type="text" formControlName="urlDrive" />
      <mat-error class="warning-message" *ngIf="urlDriveError"
        >URL no válido
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Etiqueta Especiales</mat-label>
      <mat-select formControlName="specialLabelId">
        <mat-option>
          <ngx-mat-select-search
            placeholderLabel="Buscar..."
            formControlName="searchLabel"
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="0"> N/A</mat-option>
        <mat-option *ngFor="let op of optionsLabels$ | async" [value]="op.id"
          >{{ op.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="showQuantityPerInspection">
      <div class="container-inspection">
        <mat-form-field appearance="fill">
          <mat-icon
            matPrefix
            matTooltip="Este valor se refiere a cuantas cantidades se inspeccionara una vez sea necesario hacer la inspeccion"
            >info</mat-icon
          >
          <mat-label>Cantidad a inspeccionar</mat-label>
          <input
            matInput
            formControlName="quantityPerInspection"
            type="number"
            [min]="1"
          />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Cantidad necesaria para crear inspeccion</mat-label>
          <input
            matInput
            formControlName="quantityToInspect"
            type="number"
            [min]="1"
          />
        </mat-form-field>
        <mat-error *ngIf="mainForm.hasError('inspectionInputRequired')">
          Valores de inspeccion requeridos
        </mat-error>
      </div>
    </ng-container>
    <div class="all-toggle-buttons">
      <ng-container
        [ngTemplateOutlet]="toggleOption"
        [ngTemplateOutletContext]="{
          title: 'Agregar Mediciones',
          formControlName: 'hasMeasureInspection',
          color: 'tw-text-[#f59e0b]'
        }"
      >
      </ng-container>
      <ng-container
        [ngTemplateOutlet]="toggleOption"
        [ngTemplateOutletContext]="{
          title: 'Agregar Inspeccion Visual',
          formControlName: 'hasVisualInspection',
          color: 'tw-text-[#3B82F6]'
        }"
      >
      </ng-container>
    </div>
    <div *ngIf="showVisualInspection$ | async" class="tw-mt-2">
      <mat-checkbox formControlName="hasCobotInspection">
        Activar inspección por cobot
      </mat-checkbox>
    </div>
    <ng-template
      #toggleOption
      let-title="title"
      let-formControlName="formControlName"
      let-color="color"
    >
      <span class="tw-cursor-pointer" (click)="slideWorkedToggle.toggle()">
        <span class="toggle-title">
          <mat-icon [class]="color">circle</mat-icon>
          <p>{{ title }}</p>
        </span>
        <span class="toggle-button">
          <mat-slide-toggle
            [class]="color"
            [formControlName]="formControlName"
            #slideWorkedToggle
            (click)="$event.stopPropagation()"
          ></mat-slide-toggle>
        </span>
      </span>
    </ng-template>
  </form>
  <ng-container
    [ngTemplateOutlet]="templateFormMeasures"
    [ngTemplateOutletContext]="{
      leftOptionsToSelect: leftOptionsToSelect$ | async
    }"
  ></ng-container>
</ng-template>

<ng-template
  #templateFormMeasures
  let-leftOptionsToSelect="leftOptionsToSelect"
>
  <mat-stepper #stepper="matStepper">
    <mat-step label="Registrar medidas" *ngIf="showFormForMeasures">
      <mat-form-field class="tw-w-full tw-flex">
        <mat-label>Grupo de medidas</mat-label>
        <mat-select [formControl]="selectedGroupControl">
          <mat-option
            *ngFor="let op of optionsGroup; let i = index"
            [value]="i"
          >
            {{ op }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container
        *ngFor="let measure of (measureForm$ | async)?.controls; let i = index"
      >
        <app-qc-ins-form-measure-values
          [form]="measure"
          (remove)="removeMeasureForm(i)"
        ></app-qc-ins-form-measure-values>
      </ng-container>
      <div class="tw-flex tw-justify-center">
        <button
          mat-mini-fab
          [class.add-btn]="leftOptionsToSelect > 0"
          (click)="addMeasureForm()"
          [disabled]="leftOptionsToSelect === 0"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-step>
    <mat-step label="Registrar pruebas de laboratorio">
      <app-chips-input
        placeHolder="Agregar los tipos de tests que necesita"
        inputLabel="Tests"
        [data]="inspectionTests$ | async"
        [(selectedValues)]="currentTests"
      ></app-chips-input>
    </mat-step>
    <mat-step label="Registro de certificados">
      <app-chips-input
        placeHolder="Agregar los certificados que necesita el numero de parte"
        inputLabel="Certificados"
        [data]="certificateOptions$ | async"
        [(selectedValues)]="selectedCertificates"
      ></app-chips-input>
    </mat-step>
  </mat-stepper>
</ng-template>
